import { render } from "./owlCarousel.vue?vue&type=template&id=f061db6e"
import script from "./owlCarousel.vue?vue&type=script&lang=js"
export * from "./owlCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__